

class WolfAlertFetcher {
  constructor(url) {
    this.url = url;
  }

  async fetchData() {
    try {
      const response = await fetch(this.url, {
        cache: 'no-store' // This will ensure the request is not served from cache
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  createSvg(el) {
    // Create a new SVG element
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    // Set the attributes of the SVG element
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('viewBox', '0 0 512 512');
    svg.setAttribute('height', '16');
    svg.setAttribute('width', '16');

    // Create a new path element
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    // Set the attributes of the path element
    path.setAttribute('d', 'M506.82 425.56L289 48.31a38.11 38.11 0 00-66 0L5.18 425.56a38.11 38.11 0 0033 57.19H473.8a38.11 38.11 0 0033-57.19zM277 417.64h-43.34v-45.35H277zm-4.09-67.18h-35.15l-6.14-179.37h45.69z');

    // Append the path element to the SVG element
    svg.appendChild(path);

    // Append the SVG element to the document body
    el.prepend(svg);
  }

  async createDiv(data) {
    const el = document.createElement('div');
    const container = document.createElement('div');
    const headline = document.createElement('h2');
    const paragraph = document.createElement('p');
    const link = document.createElement('a');

    headline.textContent = data.messageHeadline;
    paragraph.textContent = data.messageContent;
    link.textContent = data.cta;
    link.href = data.url;

    el.classList.add('wolf-alert');
    container.classList.add('wolf-alert-wrapper');
    container.appendChild(headline);
    container.appendChild(paragraph);
    container.appendChild(link);
    el.appendChild(container);


    const style = document.createElement('style');

    let priority = data.priority;

    if ( priority === 'high' ) {
      // headline.prepend(wolficonAlert);
      this.createSvg(headline)
    }

    // Add your CSS styles here
    style.textContent = `
      .wolf-alert {
        background-color: ${priority === 'high' ? 'var(--brand-yellow)' : 'var(--mid-gray)'};
        padding: 2rem 1rem;
      }

      .wolf-alert-wrapper {
        margin: 0 auto;
        width: 100%;

        @media (width >= 768px) {
          width: 50%;
        }
      }

      .wolf-alert-wrapper > * {
        color: ${priority === 'high' ? 'var(--dark-gray)' : 'var(--white)'};
      }

      .wolf-alert-wrapper > h2,
      .wolf-alert-wrapper > p {
        font-size: 18px;
      }
    `;

    document.head.appendChild(style);
    document.body.insertBefore(el, document.body.firstChild);
  }
}

const wolfAlertFetcher = new WolfAlertFetcher('https://cdn.ncsu.edu/wolfalert/alert.json');

// wolfAlertFetcher.fetchData().then(data => {
//   if ( data && data.active ) {
//     wolfAlertFetcher.createDiv(data);
//   }
// });